import { renderTab_unstable } from "@fluentui/react-components";
import type { AppTabProps, AppTabState } from "./AppTab.types";
import { AppTooltipContainer } from "@1js/acui-tooltip";
import * as React from "react";

export const renderAppTab = (state: AppTabState, props: AppTabProps) => {
  return (
    <AppTooltipContainer {...props} label={props.title || ""}>
      {renderTab_unstable(state)}
    </AppTooltipContainer>
  );
};
